/**
 * Vantify-specific constants
 * These constants are specific to the Vantify integration
 */

export const HEADER_VANTIFY_USERNAME = 'X-Vantify-Username';
export const HEADER_VANTIFY_PASSWORD = 'X-Vantify-Password';
export const HEADER_VANTIFY_BASE_URL = 'X-Vantify-Base-Url';
